import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as innovationAssets from '../../innovation-assets'

export const RESOURCE = {
  payload: {
    description:
      'A specific product or service that enables Attain Partners as a whole, as it relates to Innovation.',
    dimension: innovationAssets.RESOURCE.payload,
    level: 0,
    name: 'Innovation Asset',
    partialId: PartialId.Standard.create('innovation_asset'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
